// document.addEventListener("DOMContentLoaded", function() {
//   console.log('Script Loaded');
//   const canonicalUrl = document.querySelector('link[rel="canonical"]').getAttribute('href');
  
//   // Retrieve or initialize the timeline
//   let timeline = JSON.parse(sessionStorage.getItem("timeline")) || [];

//   // Log initial state
//   console.log("Current Canonical URL:", canonicalUrl);
//   console.log("Timeline (before update):", timeline);

//   // Only add new unique canonical URLs
//   if (!timeline.includes(canonicalUrl)) {
//     timeline.push(canonicalUrl);
//     sessionStorage.setItem("timeline", JSON.stringify(timeline));
//     history.pushState({ page: canonicalUrl }, "", canonicalUrl);
//     console.log("Timeline updated:", timeline);
//   }

//   // Handle back and forward navigation in the timeline
//   window.addEventListener("popstate", function(event) {
//     console.log("Popstate Event Triggered");
//     timeline = JSON.parse(sessionStorage.getItem("timeline")) || [];
//     const currentUrl = event.state ? event.state.page : canonicalUrl;
    
//     if (timeline.includes(currentUrl)) {
//       console.log("Navigating to:", currentUrl);
//       history.replaceState({ page: currentUrl }, "", currentUrl);
//     }
//   });
//   console.log("FULLLY LOADED");
// });

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.startsWith("/collections/")) {
    const url = new URL(window.location.href);

    if (!url.searchParams.has("filter.v.availability")) {
      url.searchParams.set("filter.v.availability", "1");
      window.location.replace(url.toString());
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
  console.log('TBL Loaded');
});

if (typeof window.productQuickViewButton === 'function') {
  console.log('productQuickViewButton is accessible in tbl.js');
} else {
  console.error('productQuickViewButton is not accessible in tbl.js');
}


function switchProductInModal(productHandle) {
  console.log('switchProductInModal called with productHandle:', productHandle);
  
  if (typeof window.productQuickViewButton !== 'function') {
    console.error('productQuickViewButton is not defined');
    return;
  }

  // Call productQuickViewButton with productHandle
  const quickview = window.productQuickViewButton(productHandle);
  quickview.reinitializeQuickviewWithProduct(productHandle, productHandle); // Pass the handle explicitly
}




